import React, { useState } from "react";
import CardContainer from "../CardContainer";
import { Button, Icon } from "@src/components/atoms";
import { PlotlyGraph } from "@src/components/graphs";
import { useDCContext } from "@src/context";

const BehiveGraphCard = (props) => {
  const { dataJSON, width, padding } = props;
  const dc = useDCContext();
  const [showSecondGraph, setShowSecondGraph] = useState(false);
  const handleHideSecondGraph = () => {
    setShowSecondGraph(!showSecondGraph);
  };
  return (
    <div className="w-full h-full">
      <CardContainer className="w-full" shadow={false}>
        {Array.isArray(dataJSON) && dataJSON.length > 1 ? (
          <>
            {dataJSON.map((data, index) => {
              return (
                <div key={`multigraph-${index}`}>
                  {data.controls && data.plotly?.data?.length > 0 && (
                    <div className="w-2/6">
                      <Button onClick={handleHideSecondGraph} tertiary>
                        <span>
                          {dc.getDynamicReplacement(data.controls.hide_text)}
                        </span>
                        <Icon
                          name={showSecondGraph ? "chevronDown" : "chevronUp"}
                          backgroundColor="transparent"
                          size="lg"
                          className="mr-1.5 pl-2"
                          centered={false}
                          padding={false}
                          inline={true}
                        />
                      </Button>
                    </div>
                  )}
                  {(!data.controls || showSecondGraph) && (
                    <PlotlyGraph
                      plotyJSON={data.plotly}
                      width={width}
                      padding={padding}
                    />
                  )}
                </div>
              );
            })}
          </>
        ) : (
          <PlotlyGraph
            plotyJSON={Array.isArray(dataJSON) ? dataJSON[0].plotly : dataJSON}
            width={width}
            padding={padding}
          />
        )}
      </CardContainer>
    </div>
  );
};
export default BehiveGraphCard;
